import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function BookmarkIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} stroke="white" fillOpacity={props.fillOpacity ? props.fillOpacity : '0.3'}>
      <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z" />
    </SvgIcon>
  );
}
